import { render } from "./task-board-kanban.vue?vue&type=template&id=73e77367"
import script from "./task-board-kanban.vue?vue&type=script&lang=js"
export * from "./task-board-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__